import { render, staticRenderFns } from "./PersonalDataAgreement.vue?vue&type=template&id=d4399b82&"
import script from "./PersonalDataAgreement.vue?vue&type=script&lang=js&"
export * from "./PersonalDataAgreement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports